import { render, staticRenderFns } from "./data-well.html?vue&type=template&id=5bb85b44&scoped=true&external"
import script from "./data-well.js?vue&type=script&lang=js&external"
export * from "./data-well.js?vue&type=script&lang=js&external"
import style0 from "./data-well.scss?vue&type=style&index=0&id=5bb85b44&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb85b44",
  null
  
)

export default component.exports